{
  "avalancheSize.label": "Taille d'avalanche",
  "avalancheSize.small": "petite",
  "avalancheSize.medium": "moyenne",
  "avalancheSize.large": "grande",
  "avalancheSize.very_large": "très grande",
  "avalancheSize.extreme": "extrême",
  "snowpackStability.label": "Stabilité du manteau neigeux",
  "snowpackStability.good": "bonne",
  "snowpackStability.fair": "moyenne",
  "snowpackStability.poor": "mauvaise",
  "snowpackStability.very_poor": "très mauvaise",
  "frequency.label": "Fréquence",
  "frequency.none": "aucune",
  "frequency.few": "rare",
  "frequency.some": "plusieurs",
  "frequency.many": "beaucoup",
  "dangerRating.label": "Degré de danger",
  "dangerRating.missing": "manquant",
  "dangerRating.missing.long": "Manquant",
  "dangerRating.no_snow": "pas de neige",
  "dangerRating.no_snow.long": "Pas de Neige",
  "dangerRating.no_rating": "pas noté",
  "dangerRating.no_rating.long": "Pas Noté",
  "dangerRating.low": "faible",
  "dangerRating.low.long": "Degré de danger 1 — Faible",
  "dangerRating.low.speech": "faible risque d'avalanche, donc degré de danger 1",
  "dangerRating.moderate": "limité",
  "dangerRating.moderate.long": "Degré de danger 2 — Limité",
  "dangerRating.moderate.speech": "risque d'avalanche limité, donc degré de danger 2",
  "dangerRating.considerable": "marqué",
  "dangerRating.considerable.long": "Degré de danger 3 — Marqué",
  "dangerRating.considerable.speech": "risque d'avalanche marqué, donc degré de danger 3",
  "dangerRating.high": "fort",
  "dangerRating.high.long": "Degré de danger 4 — Fort",
  "dangerRating.high.speech": "risque d'avalanche fort, donc degré de danger 4",
  "dangerRating.very_high": "très fort",
  "dangerRating.very_high.long": "Degré de danger 5 — Très Fort",
  "dangerRating.very_high.speech": "risque d'avalanche très fort, donc degré de danger 5",
  "avalancheType.label": "Type d'avalanche",
  "avalancheType.slab": "Avalanche de plaque",
  "avalancheType.loose": "Avalanche de neige meuble",
  "avalancheType.glide": "Avalanche de glissement",
  "avalancheProblem.label": "Situation avalancheuse typique",
  "avalancheProblem.coreZones.label": "Avalanche Problems with Core Zones",
  "avalancheProblem.new_snow": "Neige fraîche",
  "avalancheProblem.wind_slab": "Neige ventée",
  "avalancheProblem.persistent_weak_layers": "Neige ancienne (Sous-couche fragile persistante)",
  "avalancheProblem.wet_snow": "Avalanches mouillées (Neige humide)",
  "avalancheProblem.gliding_snow": "Avalanches de glissement (Avalanches de fond)",
  "avalancheProblem.favourable_situation": "Situation favorable",
  "avalancheProblem.cornices": "congères",
  "avalancheProblem.no_distinct_avalanche_problem": "Pas de situation avalancheuse typique",
  "avalancheProblem.new_snow.speech": "un problème de neige fraîche",
  "avalancheProblem.wind_slab.speech": "un problème de neige ventée",
  "avalancheProblem.persistent_weak_layers.speech": "un problème de neige ancienne",
  "avalancheProblem.wet_snow.speech": "un problème de neige mouillée",
  "avalancheProblem.gliding_snow.speech": "un problème de neige glissante",
  "avalancheProblem.favourable_situation.speech": "une situation favorable",
  "avalancheProblem.cornices.speech": "un problème de congères",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "pas de situation avalancheuse typique",
  "dangerPattern.label": "Modèles de danger",
  "dangerPattern.dp1": "md.1: sous-couche fragile persistante",
  "dangerPattern.dp2": "md.2: neige glissante",
  "dangerPattern.dp3": "md.3: pluie",
  "dangerPattern.dp4": "md.4: froid suivant chaud / chaud suivant froid",
  "dangerPattern.dp5": "md.5: chute de neige après une longue période de froid",
  "dangerPattern.dp6": "md.6: froid, neige légère et vent",
  "dangerPattern.dp7": "md.7: zones avec peu de neige à coté des zones enneigées",
  "dangerPattern.dp8": "md.8: givre de surface enneigé",
  "dangerPattern.dp9": "md.9: neige roulée enneigé",
  "dangerPattern.dp10": "md.10: situation de printemps",
  "aspect.N": "Nord",
  "aspect.NE": "Nord-Est",
  "aspect.E": "Est",
  "aspect.SE": "Sud-Est",
  "aspect.S": "Sud",
  "aspect.SW": "Sud-Ouest",
  "aspect.W": "Ouest",
  "aspect.NW": "Nord-Ouest",
  "tendency.label": "Tendance",
  "tendency.progression.label": "Development of avalanche danger",
  "tendency.decreasing": "Tendance: Diminution du danger d'avalanche",
  "tendency.steady": "Tendance: danger d'avalanche constant",
  "tendency.increasing": "Tendance: Augmentation du danger d'avalanche",
  "validTimePeriod.all_day": "toute la journée",
  "validTimePeriod.all_day.long": "toute la journée",
  "validTimePeriod.earlier": "plus tôt",
  "validTimePeriod.earlier.long": "plus tôt dans la journée",
  "validTimePeriod.later": "plus tard",
  "validTimePeriod.later.long": "plus tard dans la journée",
  "elevation.treeline.capitalized": "Limite de la forêt",
  "elevation.treeline": "limite de la forêt",
  "elevation.all": "Toutes les élévations",
  "elevation.below": "Au-dessous de {0}",
  "elevation.above": "Au-dessus de {0}",
  "elevation.band": "Entre {0} et {1}",
  "synopsis.label": "Météo",
  "snowpack.label": "Manteau neigeux",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Bulletin d'avalanche"
}
